import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchAllSlice as getFetchAllSliceBase,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// fetch
function getFetchAllState(state: State) {
  return getFetchAllSliceBase(state);
}

export function memoriesAreFetching(state: State): boolean {
  return hasStarted(getFetchAllState(state));
}

export function memoriesFetchSucceeded(state: State): boolean {
  return didSucceed(getFetchAllState(state));
}

export function memoriesFetchErrored(state: State): boolean {
  return didError(getFetchAllState(state));
}

export function memoriesFetchFinished(state: State) {
  return memoriesFetchSucceeded(state) || memoriesFetchErrored(state);
}
export function memoriesNeedFetching(state: State) {
  return !(memoriesFetchSucceeded(state) || memoriesAreFetching(state));
}
